import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { Button } from 'antd';
import { fireCustomEvent } from '~helpers/custom-events';

export default class MsgCenterBtn extends React.Component {
  constructor(props) {
    super(props);

    this.msgCenterBtnRef = React.createRef(null);
  }

  msgCenterParam = () => {
    const { property, student } = this.props;
    if (property && student) {
      return {
        propertyId: property.id,
        propertyName: property.name,
        cityId: property.city.id,
        cityName: property.city.name,
        studentUuid: student.userUuid,
        bookingJourney: property.bookingJourney,
      };
    }
    return {};
  };

  componentDidMount() {
    fireCustomEvent('setupModalTriggers', { types: ['messageCenter'] });

    try {
      const search = queryString.parse(window.location.search);
      if (search.landlord_open_msg_center === 'true') {
        this.msgCenterBtnRef?.current?.buttonNode?.click();
      }
    } catch (e) {
      console.error(e);
    }
  }

  handleClickMessageBtn = () => {
    this.props?.handleClickActionBtnTrack?.('Message');
  };

  render() {
    const { t } = this.props;
    return (
      <Button
        ref={this.msgCenterBtnRef}
        className="js-account-modal-contact-host longtail-booking-details__btn longtail-booking-details__btn--message"
        data-params={JSON.stringify(this.msgCenterParam())}
        onClick={this.handleClickMessageBtn}
      >
        {t('landlord.long_tail.booking_details.btn.message')}
      </Button>
    );
  }
}

MsgCenterBtn.propTypes = {
  t: PropTypes.func,
  property: PropTypes.object,
  student: PropTypes.object,
  handleClickActionBtnTrack: PropTypes.func,
};

MsgCenterBtn.defaultProps = {
  t: () => {},
  property: {},
  student: {},
};
